export enum FirestoreCollections {
  Blocks = 'blocks',
  OAuth2 = 'oauth2',
  Pages = 'pages',
  Themes = 'themes'
}
